// extracted by mini-css-extract-plugin
module.exports = {"product-buy-box-button":"ProductBuyBoxButton_product-buy-box-button__9l5jT"};